"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[77284],{

/***/ 77284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ store_chatGroupPolicyStore; },
  "Z9": function() { return /* reexport */ store_chatUtilsStore; },
  "vW": function() { return /* reexport */ store_contactDiscoveryStore; },
  "Zn": function() { return /* reexport */ store_contactSyncStore; },
  "VY": function() { return /* reexport */ store_groupMemberStore; },
  "tZ": function() { return /* reexport */ store_roomActionStore; },
  "e": function() { return /* reexport */ store_roomDetailStore; }
});

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/chat/store/chatUtilsStore.ts

var chatUtilsStore = (0,esm/* default */.ZP)(function(set) {
    return {
        showRightSidebar: false,
        showSearchMember: false,
        showInviteLink: false,
        showAddMember: false,
        showNewMessage: false,
        showUserSelection: false,
        showCreateGroup: false,
        showModalLeaveGroup: false,
        showEditRoomChat: false,
        isComposeChatFocused: false,
        setComposeChatFocuses: function(focused) {
            set({
                isComposeChatFocused: focused
            });
        },
        toggleRightSidebar: function(visible) {
            set({
                showRightSidebar: visible
            });
        },
        toggleSearchMember: function(visible) {
            set({
                showSearchMember: visible
            });
        },
        toggleInviteLink: function(visible) {
            set({
                showInviteLink: visible
            });
        },
        toggleAddMember: function(visible) {
            set({
                showAddMember: visible
            });
        },
        toggleNewMessage: function(visible) {
            set({
                showNewMessage: visible
            });
        },
        toggleUserSelection: function(visible) {
            set({
                showUserSelection: visible
            });
        },
        toggleCreateGroup: function(visible) {
            set({
                showCreateGroup: visible
            });
        },
        toggleModalLeaveGroup: function(visible) {
            set({
                showModalLeaveGroup: visible
            });
        },
        toggleEditRoomChat: function(visible) {
            set({
                showEditRoomChat: visible
            });
        },
        resetLeftSidebarView: function() {
            set({
                showCreateGroup: false,
                showNewMessage: false,
                showUserSelection: false
            });
        },
        resetRightSidebarView: function() {
            set({
                showRightSidebar: false,
                showSearchMember: false,
                showInviteLink: false,
                showAddMember: false
            });
        }
    };
});
/* harmony default export */ var store_chatUtilsStore = (chatUtilsStore);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/lib/api/chat.ts
var chat = __webpack_require__(69101);
;// CONCATENATED MODULE: ./src/features/chat/store/groupMemberStore.ts
/* eslint-disable import/no-named-as-default-member */ 





var groupMemberStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        data: {
            members: [],
            is_more: false
        },
        isLoading: false,
        offset: 0,
        userUpdated: {
            userId: 0,
            isAdmin: true
        },
        fetchGroupMember: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(groupId, offset) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (offset === 0) {
                                set({
                                    isLoading: true
                                });
                            }
                            _ctx.next = 3;
                            return chat/* default.getMemberList */.ZP.getMemberList(groupId, null, 10, offset).then(function(res) {
                                var data = res.data.data;
                                if (offset === 0) {
                                    set({
                                        data: data,
                                        isLoading: false,
                                        offset: 10
                                    });
                                } else {
                                    set({
                                        data: {
                                            members: (0,_to_consumable_array/* default */.Z)(get().data.members).concat((0,_to_consumable_array/* default */.Z)(data.members)),
                                            is_more: data.is_more
                                        },
                                        isLoading: false
                                    });
                                }
                            }).catch(function() {
                                set({
                                    isLoading: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(groupId, offset) {
                return _ref.apply(this, arguments);
            };
        }(),
        setAdminStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(groupId, userId, status) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 3;
                            return chat/* default.setAdminStatus */.ZP.setAdminStatus(groupId, {
                                user_id: userId,
                                status: status
                            }).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                                    var ref;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                ;
                                                set({
                                                    offset: 0,
                                                    isLoading: false,
                                                    userUpdated: {
                                                        userId: userId,
                                                        isAdmin: status
                                                    }
                                                });
                                                (0,AlertMessage/* default */.Z)({
                                                    content: (ref = res.data) === null || ref === void 0 ? void 0 : ref.message,
                                                    alertType: "snackbar",
                                                    messageType: "success",
                                                    hasCloseIcon: false
                                                });
                                                get().fetchGroupMember(groupId, 0);
                                            case 4:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(res) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function() {
                                set({
                                    isLoading: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(groupId, userId, status) {
                return _ref.apply(this, arguments);
            };
        }(),
        removeMember: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(groupId, userId, username) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 3;
                            return chat/* default.removeGroupMember */.ZP.removeGroupMember(groupId, {
                                user_id: userId
                            }).then(function() {
                                set({
                                    isLoading: false
                                });
                                (0,AlertMessage/* default */.Z)({
                                    content: "".concat(username, " removed from the group"),
                                    alertType: "snackbar",
                                    messageType: "success",
                                    hasCloseIcon: true
                                });
                                get().fetchGroupMember(groupId, 0);
                            }).catch(function() {
                                set({
                                    isLoading: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(groupId, userId, username) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var store_groupMemberStore = (groupMemberStore);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/features/chat/store/roomDetailStore.ts









var roomDetailStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        personal: {},
        group: {},
        isLoading: false,
        isLoadingUpdateGroup: false,
        isLoadingResetLink: false,
        fetchPersonalRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                chat/* default.getRoom */.ZP.getRoom(chatId).then(function(res) {
                                    var data = res.data.data;
                                    set({
                                        personal: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().personal), (0,_define_property/* default */.Z)({}, chatId, data))
                                    });
                                    resolve({
                                        data: data,
                                        error: false
                                    });
                                }).catch(function() {
                                    resolve({
                                        error: true
                                    });
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(chatId) {
                return _ref.apply(this, arguments);
            };
        }(),
        fetchGroupRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                chat/* default.getGroupRoom */.ZP.getGroupRoom(chatId).then(function(res) {
                                    var data = res.data.data;
                                    set({
                                        group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, data))
                                    });
                                    resolve({
                                        data: data,
                                        error: false
                                    });
                                }).catch(function() {
                                    resolve({
                                        error: true
                                    });
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(chatId) {
                return _ref.apply(this, arguments);
            };
        }(),
        updateGroupRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var chatId = params.chatId, groupId = params.groupId, restParams = (0,_object_without_properties/* default */.Z)(params, [
                                    "chatId",
                                    "groupId"
                                ]);
                                chat/* default.updateChatGroup */.ZP.updateChatGroup(groupId, restParams).then((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return chat/* default.getGroupRoom */.ZP.getGroupRoom(chatId).then(function(resGroupDetail) {
                                                    var data = resGroupDetail.data.data;
                                                    set({
                                                        group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, data))
                                                    });
                                                    resolve(true);
                                                }).catch(function() {
                                                    set({
                                                        isLoadingUpdateGroup: false
                                                    });
                                                });
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }))).catch(function() {
                                    set({
                                        isLoadingUpdateGroup: false
                                    });
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetGroupLink: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                var groupId, chatId;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            groupId = params.groupId, chatId = params.chatId;
                            _ctx.next = 3;
                            return chat/* default.resetLink */.ZP.resetLink(groupId).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                                    var data;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                data = res.data.data;
                                                set({
                                                    group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group[chatId]), {
                                                        invitation_link: data === null || data === void 0 ? void 0 : data.new_link
                                                    }))),
                                                    isLoadingResetLink: false
                                                });
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(res) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(err) {
                                var ref;
                                if ((err === null || err === void 0 ? void 0 : (ref = err.cause) === null || ref === void 0 ? void 0 : ref.status) === 403) {
                                    var ref1;
                                    (0,AlertMessage/* default */.Z)({
                                        content: err === null || err === void 0 ? void 0 : (ref1 = err.cause) === null || ref1 === void 0 ? void 0 : ref1.message,
                                        alertType: "plain-default",
                                        messageType: "error"
                                    });
                                }
                                set({
                                    isLoadingResetLink: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        refreshGroupRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                chat/* default.getGroupRoomSilent */.ZP.getGroupRoomSilent(chatId).then(function(res) {
                                    var data = res.data.data;
                                    set({
                                        group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, data))
                                    });
                                    resolve(true);
                                }).catch(function() {
                                    resolve(false);
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(chatId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var store_roomDetailStore = (roomDetailStore);

// EXTERNAL MODULE: ./src/lib/api/friends.ts
var friends = __webpack_require__(63699);
;// CONCATENATED MODULE: ./src/features/chat/store/contactSyncStore.ts
/* eslint-disable import/no-named-as-default-member */ 

var contactSyncStore = (0,esm/* default */.ZP)(function(set) {
    return {
        status: "CONTACT_STATUS_TYPE_NOT_SYNCED",
        total: 0,
        fetchStatus: function() {
            friends/* default.getContactSyncStatus */.Z.getContactSyncStatus().then(function(res) {
                var _data = res.data, _data1 = _data.data, status = _data1.status, total = _data1.total;
                set({
                    status: status,
                    total: total
                });
            }).catch(function() {});
        }
    };
});
/* harmony default export */ var store_contactSyncStore = (contactSyncStore);

;// CONCATENATED MODULE: ./src/features/chat/store/contactDiscoveryStore.ts
/* eslint-disable camelcase */ 







var contactDiscoveryStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        data: {},
        showSuggestionContacts: false,
        showSuggestionMembers: false,
        showSuggestionNewMembers: false,
        searchUser: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword, storeKey) {
                var cursor, groupId, ref, ref1, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            cursor = _args.length > 2 && _args[2] !== void 0 ? _args[2] : null, groupId = _args.length > 3 && _args[3] !== void 0 ? _args[3] : 0;
                            ;
                            set({
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().data), (0,_define_property/* default */.Z)({}, storeKey, {
                                    isLoading: true,
                                    members: ((ref = get().data[storeKey]) === null || ref === void 0 ? void 0 : ref.members) || [],
                                    nextCursor: ((ref1 = get().data[storeKey]) === null || ref1 === void 0 ? void 0 : ref1.nextCursor) || ""
                                }))
                            });
                            _ctx.next = 5;
                            return chat/* default.getSearchContactDiscovery */.ZP.getSearchContactDiscovery(keyword, cursor, 10, groupId).then(function(res) {
                                var _data = res.data.data, members = _data.members, next_cursor = _data.next_cursor;
                                var memberList = cursor ? (0,_to_consumable_array/* default */.Z)(get().data[storeKey].members).concat((0,_to_consumable_array/* default */.Z)(members)) : members;
                                set({
                                    data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().data), (0,_define_property/* default */.Z)({}, storeKey, {
                                        members: memberList,
                                        nextCursor: next_cursor,
                                        isLoading: false
                                    }))
                                });
                            }).catch(function() {});
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(keyword, storeKey) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var store_contactDiscoveryStore = (contactDiscoveryStore);

// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
;// CONCATENATED MODULE: ./src/features/chat/store/chatGroupPolicyStore.ts





var chatGroupPolicyStore = (0,esm/* default */.ZP)(function(set) {
    return {
        maxMembers: constant/* MAX_GROUP_MEMBER_DEFAULT */.cK,
        fetchMaxMembers: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return chat/* default.getMaxMemberInGroup */.ZP.getMaxMemberInGroup().then(function(res) {
                            var _data = res.data.data, maxMembers = _data.max_member;
                            // -1 for admin
                            set({
                                maxMembers: maxMembers - 1
                            });
                        }).catch(function() {});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    };
});
/* harmony default export */ var store_chatGroupPolicyStore = (chatGroupPolicyStore);

// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var stores_chat = __webpack_require__(50490);
;// CONCATENATED MODULE: ./src/features/chat/store/roomActionStore.ts
/* eslint-disable import/no-named-as-default-member */ /* eslint-disable eqeqeq */ 





var roomActionStore = (0,esm/* default */.ZP)(function(set) {
    return {
        isLoadingAcceptRequest: false,
        isLoadingRejectRequest: false,
        isLoadingAcceptInvitation: false,
        isLoadingDeleteInvitation: false,
        isLoadingBlockUnblock: false,
        respondRequestedRoom: function(param) {
            var roomId = param.roomId, respond = param.respond;
            return new Promise(function(resolve) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (respond === "accept") {
                        state.isLoadingAcceptRequest = true;
                    } else {
                        state.isLoadingRejectRequest = true;
                    }
                }));
                var request = respond === "accept" ? chat/* default.acceptRequest */.ZP.acceptRequest : chat/* default.rejectRequest */.ZP.rejectRequest;
                request(roomId).then(function(res) {
                    var rooms = stores_chat/* default.getState */.Z.getState().rooms;
                    stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        var roomIdx = rooms.invited.list.findIndex(function(room) {
                            return room.id == roomId;
                        });
                        if (roomIdx > -1) {
                            state.rooms.invited.list.splice(roomIdx, 1);
                        }
                    }));
                    set({
                        isLoadingAcceptRequest: false,
                        isLoadingRejectRequest: false
                    });
                    resolve(res.data);
                }).catch(function() {
                    set({
                        isLoadingAcceptRequest: false,
                        isLoadingRejectRequest: false
                    });
                });
            });
        },
        respondGroupInvitation: function(param) {
            var chatId = param.chatId, action = param.action;
            return new Promise(function(resolve) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (action === "ACTION_ACCEPT") {
                        state.isLoadingAcceptInvitation = true;
                    } else {
                        state.isLoadingDeleteInvitation = true;
                    }
                }));
                chat/* default.respondInvitation */.ZP.respondInvitation(chatId, action).then(function(res) {
                    if (action === "ACTION_REJECT") {
                        var rooms = stores_chat/* default.getState */.Z.getState().rooms;
                        var roomIdx = rooms.invited.list.findIndex(function(room) {
                            return room.id == chatId;
                        });
                        if (roomIdx > -1) {
                            stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                                state.rooms.invited.list.splice(roomIdx, 1);
                            }));
                        }
                    }
                    set({
                        isLoadingAcceptInvitation: false,
                        isLoadingDeleteInvitation: false
                    });
                    resolve(res.data);
                }).catch(function() {
                    set({
                        isLoadingAcceptInvitation: false,
                        isLoadingDeleteInvitation: false
                    });
                });
            });
        },
        blockUnblockUser: function(param) {
            var userId = param.userId, block = param.block, username = param.username;
            return new Promise(function(resolve) {
                var request = block ? user/* default.blockUser */.Z.blockUser : user/* default.unblockUser */.Z.unblockUser;
                request(userId).then(function(res) {
                    var roomIdx = stores_chat/* default.getState */.Z.getState().rooms.default.list.findIndex(function(room) {
                        var ref, ref1;
                        return ((ref = room.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.personal) === null || ref1 === void 0 ? void 0 : ref1.user_id) === userId;
                    });
                    if (roomIdx > -1) {
                        stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                            state.rooms.default.list[roomIdx].attributes.personal.is_blocked = block;
                        }));
                    }
                    if (block) {
                        (0,AlertMessage/* default */.Z)({
                            content: "".concat(username, " berhasil diblock "),
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                    } else {
                        (0,AlertMessage/* default */.Z)({
                            content: "unblock ".concat(username, " berhasil"),
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                    }
                    resolve(res.data);
                }).catch(function() {
                    (0,AlertMessage/* default */.Z)({
                        content: "Blocking user gagal",
                        messageType: "error",
                        alertType: "snackbar",
                        hasCloseIcon: true
                    });
                });
            });
        },
        muteUnmuteRoom: function(param) {
            var chatId = param.chatId, muted = param.muted;
            return new Promise(function(resolve) {
                chat/* default.muteNotification */.ZP.muteNotification(chatId, muted).then(function(res) {
                    var data = res.data.data;
                    if (data) {
                        var roomIdx = stores_chat/* default.getState */.Z.getState().rooms.default.list.findIndex(function(room) {
                            return (room.type === "ROOM_TYPE_GROUP" || room.type === "ROOM_TYPE_BROADCAST") && room.id === parseInt(String(chatId), 10);
                        });
                        stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                            state.rooms.default.list[roomIdx].status.is_muted = muted;
                        }));
                        if (muted) {
                            (0,AlertMessage/* default */.Z)({
                                content: "Notification Muted",
                                messageType: "success",
                                alertType: "snackbar",
                                hasCloseIcon: true
                            });
                        } else {
                            (0,AlertMessage/* default */.Z)({
                                content: "Notification Unmuted",
                                messageType: "success",
                                alertType: "snackbar",
                                hasCloseIcon: true
                            });
                        }
                    }
                    resolve(data);
                }).catch(function() {
                    (0,AlertMessage/* default */.Z)({
                        content: "Gagal menyimpan aturan notifikasi",
                        messageType: "error",
                        alertType: "snackbar",
                        hasCloseIcon: true
                    });
                });
            });
        }
    };
});
/* harmony default export */ var store_roomActionStore = (roomActionStore);

;// CONCATENATED MODULE: ./src/features/chat/store/index.ts









/***/ }),

/***/ 50490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_chat; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/api/chat.ts
var chat = __webpack_require__(69101);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
;// CONCATENATED MODULE: ./src/stores/chat/message-actions.ts
/* eslint-disable import/no-named-as-default-member */ 









var actions = function(set, get) {
    return {
        fetchMessage: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var chatId = params.chatId, roomId = params.roomId, type = params.type, isFetchPrev = params.isFetchPrev, isFetchNext = params.isFetchNext, restParams = (0,_object_without_properties/* default */.Z)(params, [
                                    "chatId",
                                    "roomId",
                                    "type",
                                    "isFetchPrev",
                                    "isFetchNext"
                                ]);
                                if (isFetchPrev) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoadingPrevMessage = true;
                                    }));
                                } else if (isFetchNext) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoadingNextMessage = true;
                                    }));
                                } else {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoading = true;
                                    }));
                                }
                                var request = chat/* default.getPersonalMessage */.ZP.getPersonalMessage;
                                switch(type){
                                    case "group":
                                        request = chat/* default.getGroupMessage */.ZP.getGroupMessage;
                                        break;
                                    case "broadcast":
                                        request = chat/* default.getBroadcastMessage */.ZP.getBroadcastMessage;
                                        break;
                                    default:
                                        request = chat/* default.getPersonalMessage */.ZP.getPersonalMessage;
                                }
                                var id = type === "personal" ? chatId : roomId;
                                request(id, restParams).then(function(res) {
                                    var ref;
                                    var data = res.data.data;
                                    var messages = [];
                                    var conversation = get().conversation.messages[chatId];
                                    var prevCursorId = conversation ? conversation === null || conversation === void 0 ? void 0 : (ref = conversation.cursor) === null || ref === void 0 ? void 0 : ref.prev : "";
                                    if (conversation && isFetchPrev) {
                                        messages = (0,_to_consumable_array/* default */.Z)(conversation.messages).concat((0,_to_consumable_array/* default */.Z)(data.messages));
                                    } else if (conversation && isFetchNext) {
                                        messages = (0,_to_consumable_array/* default */.Z)(data.messages).concat((0,_to_consumable_array/* default */.Z)(conversation.messages));
                                    } else {
                                        messages = data.messages;
                                    }
                                    var hasMore = data.is_more;
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        var ref;
                                        state.conversation.messages[chatId] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                            cursor: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.cursor), {
                                                prev: isFetchNext ? prevCursorId : data === null || data === void 0 ? void 0 : (ref = data.cursor) === null || ref === void 0 ? void 0 : ref.prev
                                            }),
                                            messages: messages,
                                            is_more: hasMore
                                        });
                                        state.conversation.isLoading = false;
                                        state.conversation.isLoadingPrevMessage = false;
                                        state.conversation.isLoadingNextMessage = false;
                                    }));
                                    resolve(data);
                                }).catch(function() {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.isLoading = false;
                                        state.conversation.isLoadingPrevMessage = false;
                                        state.conversation.isLoadingNextMessage = false;
                                    }));
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        pushMessage: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                var message, chatId, ref, _conversation, localMessages, messages, currentLocalMessage, localMessageIndex, currentMessage, isOnConvo;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            message = params.message, chatId = params.chatId;
                            ref = get(), _conversation = ref.conversation, localMessages = _conversation.localMessages, messages = _conversation.messages;
                            currentLocalMessage = localMessages[chatId];
                            // remove message from local message
                            if (currentLocalMessage) {
                                localMessageIndex = currentLocalMessage.findIndex(function(msg) {
                                    return msg.reference_id === (params === null || params === void 0 ? void 0 : params.reference_id);
                                });
                                if (localMessageIndex > -1) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        state.conversation.localMessages[chatId].splice(localMessageIndex, 1);
                                    }));
                                }
                            }
                            currentMessage = messages[chatId];
                            // save message to store
                            if (currentMessage) {
                                isOnConvo = currentMessage.messages.some(function(item) {
                                    return item.id === message.id;
                                });
                                if (!isOnConvo) {
                                    set((0,immer_esm/* default */.ZP)(function(state) {
                                        var ref;
                                        state.conversation.messages[chatId].messages.unshift(message);
                                        if ((ref = params.room_status) === null || ref === void 0 ? void 0 : ref.is_mentioned) {
                                            var hasMentioned = currentMessage.mentioned_message_ids;
                                            if (hasMentioned) {
                                                state.conversation.messages[chatId].mentioned_message_ids.push(message === null || message === void 0 ? void 0 : message.id);
                                            } else {
                                                state.conversation.messages[chatId].mentioned_message_ids = [
                                                    message === null || message === void 0 ? void 0 : message.id, 
                                                ];
                                            }
                                        }
                                    }));
                                }
                            } else {
                                set((0,immer_esm/* default */.ZP)(function(state) {
                                    state.conversation.messages[chatId] = {
                                        messages: [
                                            message
                                        ],
                                        cursor: {
                                            prev: "",
                                            next: ""
                                        },
                                        is_more: false,
                                        mentioned_message_ids: []
                                    };
                                }));
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        selectMessage: function(params) {
            var messageId = params.messageId, chatId = params.chatId, checked = params.checked, align = params.align;
            var conversation = get().conversation;
            if (conversation.selected.messageIds.length >= 10 && checked) {
                (0,AlertMessage/* default */.Z)({
                    content: "You can select up to 10 messages",
                    messageType: "error",
                    alertType: "snackbar",
                    hasCloseIcon: true
                });
                return;
            }
            var chatIndex = conversation.messages[chatId].messages.findIndex(function(convo) {
                return convo.id === messageId;
            });
            set((0,immer_esm/* default */.ZP)(function(state) {
                var index = conversation.selected.messageIds.indexOf(messageId);
                if (checked && index < 0) {
                    state.conversation.selected.messageIds.push(messageId);
                    state.conversation.selected.messageAlign.push(align);
                } else if (index >= 0) {
                    state.conversation.selected.messageIds.splice(index, 1);
                    state.conversation.selected.messageAlign.splice(index, 1);
                }
                state.conversation.messages[chatId].messages[chatIndex].selected = checked;
            }));
        },
        cancelSelect: function(params) {
            var chatId = params.chatId;
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.conversation.selected.messageIds = [];
                state.conversation.selected.messageAlign = [];
                state.conversation.messages[chatId].messages = state.conversation.messages[chatId].messages.map(function(message) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, message), {
                        selected: false
                    });
                });
            }));
        },
        doResetSelectedConversation: function() {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.conversation.selected.messageIds = [];
                state.conversation.selected.messageAlign = [];
            }));
        },
        deleteMessages: function(params) {
            return new Promise(function(resolve, reject) {
                var chatId = params.chatId, messageIds = params.messageIds;
                chat/* default.deleteBulkChatMessage */.ZP.deleteBulkChatMessage(messageIds).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    if (res.status === 200) {
                        var messages = get().conversation.messages[chatId].messages;
                        set((0,immer_esm/* default */.ZP)(function(state) {
                            // eslint-disable-next-line array-callback-return
                            messageIds.map(function(messageId) {
                                var deletedMessageIdx = messages.findIndex(function(message) {
                                    return messageId === message.id;
                                });
                                if (deletedMessageIdx > -1) {
                                    // set flag to deleted
                                    state.conversation.messages[chatId].messages[deletedMessageIdx].body.conversation.flag.is_deleted = true;
                                    // change text message
                                    state.conversation.messages[chatId].messages[deletedMessageIdx].body.conversation.text = "You deleted this message";
                                }
                            });
                        }));
                        resolve(data);
                    } else {
                        reject(error);
                    }
                }).catch(function(error) {
                    reject(error);
                });
            });
        },
        clearMessages: function(chatId) {
            return new Promise(function(resolve, reject) {
                chat/* default.clearChat */.ZP.clearChat(chatId).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    if (data) {
                        set((0,immer_esm/* default */.ZP)(function(state) {
                            state.conversation.messages[chatId] = {
                                cursor: {
                                    prev: "",
                                    next: ""
                                },
                                messages: [],
                                is_more: false,
                                mentioned_message_ids: []
                            };
                        }));
                        resolve(data);
                    } else {
                        reject(error);
                    }
                }).catch(function() {});
            });
        },
        cancelReply: function() {
            set({
                reply: {
                    to_id: 0,
                    visible: false
                }
            });
        },
        replyMessage: function(messageId) {
            set({
                reply: {
                    to_id: messageId,
                    visible: true
                }
            });
        },
        sendMessage: function(params, chatId) {
            return new Promise(function(resolve) {
                chat/* default.sendChatV2 */.ZP.sendChatV2(params).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    if (data) {
                        var message = data.message;
                        get().findAndClearLocalMessages(chatId, params === null || params === void 0 ? void 0 : params.reference_id).then(function() {
                            get().pushMessage({
                                message: message,
                                chatId: chatId,
                                reference_id: params === null || params === void 0 ? void 0 : params.reference_id
                            });
                        });
                        resolve(data);
                    } else {
                        resolve(error);
                    }
                }).catch(function(err) {
                    get().changeLocalMessageStatus(chatId, params.reference_id, "MESSAGE_STATUS_ERROR");
                    resolve(err);
                });
            });
        },
        pushLocalMessage: function(params) {
            if (get().conversation.localMessages[params.data.chatId]) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.conversation.localMessages[params.data.chatId].push(params);
                }));
            } else {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.conversation.localMessages[params.data.chatId] = [
                        params
                    ];
                }));
            }
        },
        changeLocalMessageStatus: function(chatId, referenceId, status) {
            var localMessageIndex = get().conversation.localMessages[chatId].findIndex(function(msg) {
                return msg.reference_id === referenceId;
            });
            if (localMessageIndex > -1) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    state.conversation.localMessages[chatId][localMessageIndex].data.status = status;
                }));
            }
        },
        findAndClearLocalMessages: function(chatId, reference_id) {
            var ref = get(), localMessages = ref.conversation.localMessages;
            return new Promise(function(res, rej) {
                var currentLocalMessage = localMessages[chatId];
                // remove message from local message
                if (currentLocalMessage) {
                    var localMessageIndex = currentLocalMessage.findIndex(function(msg) {
                        return msg.reference_id === reference_id;
                    });
                    if (localMessageIndex > -1) {
                        set((0,immer_esm/* default */.ZP)(function(state) {
                            state.conversation.localMessages[chatId].splice(localMessageIndex, 1);
                        }));
                        res();
                    } else {
                        rej();
                    }
                }
            });
        },
        clearLocalMessages: function(chatId) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.conversation.localMessages[chatId] = null;
            }));
        },
        readMessage: function(chatId, roomType) {
            return new Promise(function(resolve) {
                chat/* default.readChat */.ZP.readChat(chatId).then(function(res) {
                    var data = res.data.data;
                    var fetchUnreadCount = useGetChatUnreadCount/* useGetChatUnreadCount.getState */.H.getState().fetchUnreadCount;
                    // update the chat notification counter
                    fetchUnreadCount();
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        var roomIdx = get().rooms[roomType].list.findIndex(// eslint-disable-next-line eqeqeq
                        function(room) {
                            return "".concat(room.id) === "".concat(chatId);
                        });
                        if (roomIdx > -1) {
                            state.rooms[roomType].list[roomIdx].unread_count = 0;
                            state.rooms[roomType].list[roomIdx].status.is_mentioned = false;
                        }
                    }));
                    resolve(data);
                }).catch(function() {});
            });
        },
        readMentionedMessage: function(chatId, messageId) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                var messageIndex = state.conversation.messages[chatId].mentioned_message_ids.findIndex(function(item) {
                    return item === messageId;
                });
                if (messageIndex > -1) {
                    state.conversation.messages[chatId].mentioned_message_ids.splice(messageIndex, 1);
                }
            }));
        },
        forwardMessage: function(params) {
            return new Promise(function(resolve, reject) {
                var chatId = params.chatId, bodyParams = (0,_object_without_properties/* default */.Z)(params, [
                    "chatId"
                ]);
                chat/* default.forwardChat */.ZP.forwardChat(bodyParams).then(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                        var data;
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    data = res.data.data;
                                    resolve(data);
                                case 2:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function(res) {
                        return _ref.apply(this, arguments);
                    };
                }()).catch(function(err) {
                    reject(err);
                });
            });
        },
        updateMessageFromWS: function(params) {
            var chatId = params.chatId, messageId = params.messageId, message = params.message;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (state.conversation.messages[chatId]) {
                    var messageIdx = state.conversation.messages[chatId].messages.findIndex(function(msg) {
                        return msg.id === messageId;
                    });
                    if (messageIdx > -1) {
                        state.conversation.messages[chatId].messages[messageIdx] = message;
                    }
                }
            }));
        }
    };
};
/* harmony default export */ var message_actions = (actions);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/utils/chat.js
var utils_chat = __webpack_require__(21779);
;// CONCATENATED MODULE: ./src/stores/chat/room-action.ts
/* eslint-disable import/no-named-as-default-member */ 








var room_action_actions = function(set, get) {
    return {
        fetchDefaultRooms: function(params, sourceToken) {
            return new Promise(function(resolve, reject) {
                var offset = params.offset, _hasLoading = params.hasLoading, hasLoading = _hasLoading === void 0 ? true : _hasLoading;
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (hasLoading) {
                        if (offset === 0) {
                            state.rooms.default.list = [];
                            state.rooms.default.isLoading = true;
                        } else {
                            state.rooms.default.isLoadingMore = true;
                        }
                    }
                }));
                chat/* default.getRooms */.ZP.getRooms(params, sourceToken).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        if (error) {
                            state.rooms.default.isLoading = false;
                            state.rooms.default.isLoadingMore = false;
                        } else {
                            if (hasLoading && offset !== 0) {
                                var concatRooms = (0,utils_chat/* uniq */.j)(state.rooms.default.list.concat(data.rooms), function(rooms) {
                                    return rooms.id;
                                });
                                state.rooms.default.list = concatRooms;
                            } else {
                                state.rooms.default.list = data.rooms;
                            }
                            state.rooms.default.unreadRequest = data === null || data === void 0 ? void 0 : data.unread_request;
                            state.rooms.default.totalInvited = data === null || data === void 0 ? void 0 : data.total_invited;
                            state.rooms.default.pagination = data === null || data === void 0 ? void 0 : data.pagination;
                        }
                        if (offset === 0) {
                            state.rooms.default.isLoading = false;
                        } else {
                            state.rooms.default.isLoadingMore = false;
                        }
                    }));
                    resolve(data);
                }).catch(function(err) {
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        state.rooms.default.isLoading = false;
                        state.rooms.default.isLoadingMore = false;
                    }));
                    reject(err);
                });
            });
        },
        fetchInvitedRooms: function(params) {
            return new Promise(function(resolve, reject) {
                var offset = params.offset, _hasLoading = params.hasLoading, hasLoading = _hasLoading === void 0 ? true : _hasLoading;
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (offset === 0 && hasLoading) {
                        state.rooms.invited.list = [];
                        state.rooms.invited.isLoading = true;
                    } else {
                        state.rooms.invited.isLoadingMore = true;
                    }
                }));
                chat/* default.getRequestedRooms */.ZP.getRequestedRooms(params).then(function(res) {
                    var _data = res.data, data = _data.data, error = _data.error;
                    // on message request still using old calculation for pagination is_last_page
                    var pagination = {
                        is_last_page: data.rooms.length < constant/* TOTAL_ROOM_PER_PAGE */.IQ
                    };
                    var requestedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                        pagination: pagination
                    });
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        if (error) {
                            state.rooms.invited.isLoading = true;
                            state.rooms.default.isLoadingMore = false;
                        } else if (hasLoading && Number(offset) > 0) {
                            var concatRooms = (0,utils_chat/* uniq */.j)(state.rooms.invited.list.concat(data.rooms), function(rooms) {
                                return rooms.id;
                            });
                            state.rooms.invited.list = concatRooms;
                            state.rooms.invited.pagination = pagination;
                        } else {
                            state.rooms.invited.list = data.rooms;
                            state.rooms.invited.pagination = pagination;
                        }
                        if (offset === 0) {
                            state.rooms.invited.isLoading = false;
                        } else {
                            state.rooms.invited.isLoadingMore = false;
                        }
                    }));
                    resolve(requestedData);
                }).catch(function(err) {
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        state.rooms.invited.isLoading = false;
                        state.rooms.invited.isLoadingMore = false;
                    }));
                    reject(err);
                });
            });
        },
        updateRoomListFromWS: function(params) {
            var ref;
            var newChat = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                last_message: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.last_message), {
                    // prevent missing text attributes on first time chat
                    text: (params === null || params === void 0 ? void 0 : (ref = params.last_message) === null || ref === void 0 ? void 0 : ref.text) || ""
                })
            });
            var isDefaultChat = newChat.state === "ROOM_STATE_ACCEPTED";
            // decide where to place updated chat/room
            // rooms is for private, and requests is for request chat
            var stateBucket = isDefaultChat ? "default" : "invited";
            var rooms = get().rooms;
            var fetchUnreadCount = useGetChatUnreadCount/* useGetChatUnreadCount.getState */.H.getState().fetchUnreadCount;
            var roomIdx = rooms[stateBucket].list.findIndex(function(room) {
                return room.id === newChat.id;
            });
            fetchUnreadCount();
            set((0,immer_esm/* default */.ZP)(function(state) {
                var ref, ref1;
                var isRoomAvail = roomIdx > -1;
                var isUpdateRoomList = (newChat === null || newChat === void 0 ? void 0 : newChat.last_message) !== ((ref1 = (ref = rooms[stateBucket]) === null || ref === void 0 ? void 0 : ref.list[roomIdx]) === null || ref1 === void 0 ? void 0 : ref1.last_message);
                if (isUpdateRoomList) {
                    if (isRoomAvail) {
                        state.rooms[stateBucket].list.splice(roomIdx, 1);
                    }
                    state.rooms[stateBucket].list.unshift(newChat);
                }
            }));
        },
        deleteChatRoom: function(chatId) {
            return new Promise(function(resolve) {
                chat/* default.deleteChatRoom */.ZP.deleteChatRoom(chatId).then(function(res) {
                    var data = res.data.data;
                    var roomId = data.room_id;
                    var defaultRoomsStoreData = get().rooms.default;
                    set((0,immer_esm/* default */.ZP)(function(state) {
                        // remove all data related to `roomId`
                        var roomIdx = defaultRoomsStoreData.list.findIndex(function(room) {
                            return room.id === roomId;
                        });
                        if (roomIdx > -1) {
                            var newChats = (0,_to_consumable_array/* default */.Z)(defaultRoomsStoreData.list);
                            newChats.splice(roomIdx, 1);
                            // rearrange chat list
                            state.rooms.default.list = newChats;
                        }
                        if (state.conversation[roomId]) {
                            delete state.conversation[roomId];
                        }
                    }));
                    resolve(data);
                }).catch(function() {});
            });
        },
        clearLastMessage: function(chatId) {
            var defaultRoomsStoreData = get().rooms.default;
            // remove last message
            var roomIdx = defaultRoomsStoreData.list.findIndex(function(room) {
                return Number(room.id) === Number(chatId);
            });
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (roomIdx > -1) {
                    // update last message text to null
                    state.rooms.default.list = Object.assign([], defaultRoomsStoreData.list, (0,_define_property/* default */.Z)({}, roomIdx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultRoomsStoreData.list[roomIdx]), {
                        last_message: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultRoomsStoreData.list[roomIdx].last_message), {
                            text: "",
                            sender_username: "",
                            type: "ATTACHMENT_TYPE_UNSPECIFIED",
                            is_deleted: false,
                            id: 0
                        })
                    })));
                }
            }));
        }
    };
};
/* harmony default export */ var room_action = (room_action_actions);

;// CONCATENATED MODULE: ./src/stores/chat/index.ts





var initialState = {
    conversation: {
        messages: {},
        localMessages: {},
        selected: {
            messageIds: [],
            messageAlign: []
        },
        isLoading: false,
        isLoadingPrevMessage: false,
        isLoadingNextMessage: false
    },
    rooms: {
        default: {
            list: [],
            totalInvited: 0,
            unreadRequest: 0,
            isLoading: false,
            isLoadingMore: false,
            pagination: {
                is_last_page: false
            }
        },
        invited: {
            list: [],
            isLoading: false,
            isLoadingMore: false,
            pagination: {
                is_last_page: false
            }
        }
    },
    reply: {
        to_id: 0,
        visible: false
    }
};
var useChatStore = (0,esm/* default */.ZP)(function() {
    for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
        arg[_key] = arguments[_key];
    }
    return (0,_object_spread/* default */.Z)({}, initialState, message_actions.apply(void 0, (0,_to_consumable_array/* default */.Z)(arg)), room_action.apply(void 0, (0,_to_consumable_array/* default */.Z)(arg)));
});
/* harmony default export */ var stores_chat = (useChatStore);


/***/ }),

/***/ 9986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useGetChatUnreadCount; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42435);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_chat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69101);







var initialState = {
    count: 0,
    hasNewMessage: false
};
var useGetChatUnreadCount = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_3__/* .immer */ .n)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        resetCounter: function resetCounter() {
            set({
                count: 0,
                hasNewMessage: false
            });
        },
        fetchUnreadCount: function fetchUnreadCount() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return lib_api_chat__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getUnreadCount */ .ZP.getUnreadCount();
                        case 2:
                            response = _ctx.sent;
                            data = response.data.data;
                            set(function(draft) {
                                draft.count = data.count;
                                draft.hasNewMessage = data.has_new_message;
                            });
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        }
    });
}));


/***/ })

}]);